import { pathfindingAStarNoDiagonal, SmartEdge, svgDrawSmoothLinePath } from '@jalez/react-flow-smart-edge';
import type { EdgeProps } from '@xyflow/react';
import { useNodes } from '@xyflow/react';


export function AgentSmartEdge( props: EdgeProps ) {
  const nodes = useNodes();

  return (
    <SmartEdge
      { ...props }
      nodes={ nodes }
      options={ {
        drawEdge: svgDrawSmoothLinePath,
        generatePath: pathfindingAStarNoDiagonal,
        nodePadding: 80,
        gridRatio: 20
      } }
    />
  );
}
